// MAZID SCHOOL CONNECT — File d'attente hors-ligne
// Les écritures effectuées sans connexion sont stockées localement puis
// rejouées automatiquement dès que le réseau revient.
import axios from "axios";

const QUEUE_KEY = "mazid_offline_queue";

// Endpoints SÛRS à rejouer automatiquement (préfixes, méthodes d'écriture)
export const REPLAYABLE_PREFIXES = [
  "/reading/progress",       // progression de lecture
  "/erp/pointage/clock-in",  // pointage arrivée
  "/erp/pointage/clock-out", // pointage départ
  "/gate/scan",              // scans portail entrées/sorties
  "/erp/signalements",       // signalements
  "/erp/notifications/",     // marquer notifications lues
  "/messages",               // messagerie interne
  "/canteen/scan",           // pointage repas cantine
];

export const isReplayable = (method, url = "") => {
  if (!["post", "patch", "put"].includes((method || "").toLowerCase())) return false;
  const path = url.startsWith("http") ? new URL(url).pathname.replace(/^\/api/, "") : url;
  return REPLAYABLE_PREFIXES.some((p) => path.startsWith(p));
};

export const getQueue = () => {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; }
};

const setQueue = (q) => localStorage.setItem(QUEUE_KEY, JSON.stringify(q));

export const enqueue = (method, url, data) => {
  const q = getQueue();
  q.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, method, url, data, ts: new Date().toISOString() });
  setQueue(q);
  window.dispatchEvent(new CustomEvent("mazid-queue-changed", { detail: { count: q.length } }));
  return q.length;
};

let flushing = false;

// Rejoue la file d'attente. Retourne { done, failed }.
export const flushQueue = async () => {
  if (flushing) return { done: 0, failed: 0 };
  flushing = true;
  let done = 0, failed = 0;
  try {
    let q = getQueue();
    if (q.length === 0) return { done, failed };
    const token = localStorage.getItem("mazid_token");
    const base = `${process.env.REACT_APP_BACKEND_URL}/api`;
    for (const item of [...q]) {
      try {
        await axios.request({
          method: item.method, url: base + item.url, data: item.data, timeout: 20000,
          headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        });
        done += 1;
        q = q.filter((x) => x.id !== item.id);
        setQueue(q);
      } catch (e) {
        if (e.response) {
          // Le serveur a répondu (4xx/5xx) : l'action n'est plus rejouable, on la retire
          q = q.filter((x) => x.id !== item.id);
          setQueue(q);
          failed += 1;
        } else {
          break; // toujours hors-ligne : on réessaiera plus tard
        }
      }
    }
  } finally {
    flushing = false;
    window.dispatchEvent(new CustomEvent("mazid-queue-changed", { detail: { count: getQueue().length } }));
  }
  return { done, failed };
};
